import Steps from 'app/components/UI-Elements/Navigation/Steps'
import { useMemo } from 'react'
import * as React from 'react'

type Props = {
  rental: IRental
}

const StatusInfoSteps: React.FC<Props> = ({ rental }) => {
  const steps = useMemo(
    () =>
      rental.status_info.stepper_data.steps.map((step) => ({
        title: <h6>{step}</h6>,
        key: step
      })),
    [rental]
  )

  return (
    <Steps
      status={rental.status_info.stepper_data.stepper_status}
      current={rental.status_info.stepper_data.active_step}
      steps={steps}
    />
  )
}

export default StatusInfoSteps
